import script from "./TendenciaView.vue?vue&type=script&setup=true&lang=js"
export * from "./TendenciaView.vue?vue&type=script&setup=true&lang=js"

import "./TendenciaView.vue?vue&type=style&index=0&id=4da420f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4da420f0"]])

export default __exports__